import { Tabs } from "antd";
import React from "react";
import CaseDocket from "./case-docket/case-docket";
import CaseRemarks from "./case-remarks/case-remarks";
import CaseStatus from "./case-status/case-status";
import CaseSummary from "./case-summary/case-summary";
import CaseBalanceDetail from "./case-balance/case-balance-detail";
import CasePayments from "./case-payments/case-payments";
import CasePriors from "./case-priors/case-priors";
import CaseAka from "./case-aka/case-aka";
import getConfigs from "../../GetConfigs";

const CaseDetailTabs = ({ ...props }) => {
  const { activeTab, handleTabChange } = props;
  const configurations = getConfigs([
    "ctStatusPage",
    "ctDocketPage",
    "ctRemarkPage",
    "ctBalance",
    "ctPayments",
    "ctPriors",
    "ctAKA",
    "ctAttachmentsPage"
  ]);

  return (
    <Tabs activeKey={activeTab} onChange={(val) => handleTabChange(val)}>
      <Tabs.TabPane key="1" tab="Summary">
        <CaseSummary />
      </Tabs.TabPane>
      {configurations.ctStatusPage === "Y" || (configurations.ctStatusPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="2" tab="Status">
          <CaseStatus civilTab={false} />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctDocketPage === "Y" || (configurations.ctDocketPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="3" tab="Docket">
          <CaseDocket civilTab={false} />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctRemarkPage === "Y" || (configurations.ctRemarkPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="4" tab="Remarks">
          <CaseRemarks />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctBalance === "Y" || (configurations.ctBalance === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="5" tab="Balance">
          <CaseBalanceDetail />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctPayments === "Y" || (configurations.ctPayments === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="6" tab="Payments">
          <CasePayments />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctPriors === "Y" || (configurations.ctPriors === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="7" tab="Priors">
          <CasePriors />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctAKA === "Y" || (configurations.ctAKA === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="8" tab="AKA">
          <CaseAka />
        </Tabs.TabPane>
      ) : null}
      {configurations.ctAttachmentsPage === "Y" || (configurations.ctAttachmentsPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="9" tab="Attachments">
          Coming Soon
          {/* <CaseAttachment /> */}
        </Tabs.TabPane>
      ) : null}
    </Tabs>
  );
};

export default CaseDetailTabs;
